import { PayloadAction } from '@reduxjs/toolkit';
import { IPreviewTemplateOverrides, ProjectStateReducerCreator } from '../types';

const setPreviewTemplateOverridesReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<IPreviewTemplateOverrides>) => {
    // intentionally using undefined so that null values can be set
    if (action.payload?.themeMode !== undefined) {
      state.previewTemplateOverrides.themeMode = action.payload.themeMode;
    }
    if (action.payload?.themePack !== undefined) {
      state.previewTemplateOverrides.themePack = action.payload.themePack;
    }
  });
};

export default setPreviewTemplateOverridesReducer;
